const setUserInitialAngles = (game: any, userData: any) : any => {

    let numberOfPlayers : number = game?.players.length;
    let userAnglesOfTheirInitialPositions: any = {};

    if (numberOfPlayers === 2) {
        userAnglesOfTheirInitialPositions = {
            0: 90,
            1: 270,
        }
    }

    if (numberOfPlayers === 3) {
        userAnglesOfTheirInitialPositions = {
            0: 40,
            1: 140,
            2: 270
        }
    }
    
    if (numberOfPlayers === 4) {
        userAnglesOfTheirInitialPositions = {
            0: 0,
            1: 90,
            2: 180,
            3: 270
        }
    }

    if (numberOfPlayers === 5) {
        userAnglesOfTheirInitialPositions = {
            0: 0,
            1: 55,
            2: 125,
            3: 180,
            4: 270
        }
    }

    if (numberOfPlayers === 6) {
        userAnglesOfTheirInitialPositions = {
            0: 0,
            1: 40,
            2: 90,
            3: 140,
            4: 180,
            5: 270
        }
    }

  return userAnglesOfTheirInitialPositions;

};

export default setUserInitialAngles;
